import React from 'react'
import { Button } from 'reactstrap'
import styled from 'styled-components'

const BannerWrapper = styled.div`
  width: 100%;
  height: 60px;
  position: sticky;
  @media (max-width: 600px) {
    top: 80px;
  }
  top: 90px;
  z-index: 10000;
  background: #ab9157;
`

const BannerContent = styled.div`
  display: flex;
  padding: 16px 30px 16px 16px;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: space-around;
`

const Title = styled.div`
  font-size: 15px;
  font-weight: bold;
  color: #fff;
  @media (min-width: 600px) {
    font-size: 20px;
  }
`

const ButtonImageLink = styled.a``

const StyledButton = styled(Button)`
  position: absolute;
  top: 6px;
  right: 8px;
  @media (min-width: 600px) {
    right: 12px;
  }
`

const SmartBannerAd = ({
  appStoreUrl,
  altText,
  image,
  handleCtaClick,
  handleDismiss
}) => {
  return (
    <BannerWrapper>
      <BannerContent>
        <Title>Download the app today</Title>
        <ButtonImageLink href={appStoreUrl} onClick={handleCtaClick}>
          <img src={image} alt={altText} height='40' />
        </ButtonImageLink>
      </BannerContent>
      <StyledButton close onClick={handleDismiss} />
    </BannerWrapper>
  )
}

export default SmartBannerAd
